import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { getModule } from 'store/actions/modules'
import Trigger from 'components/Trigger'
import useContent from 'store/content'

const Text = dynamic(import('components/Text'))
const Subtitle = dynamic(import('components/Subtitle'))
const Picture = dynamic(import('components/Picture'))
const LinkButton = dynamic(import('components/LinkButton'))

// TODO: put in DB
const TEMPLATES = {
  default: [],
  AirCanada: [
    {
      name: 'custom.disponibilitees',
      label: 'availability',
      helpMessage: 'availabilityHelp',
      inputType: 'text',
      displayType: 'Text',
    },
    {
      name: 'custom.allergiesImg',
      label: 'allergies',
      helpMessage: 'allergiesHelp',
      inputType: 'file',
      accept: 'image/jpeg, image/png, image/x-png, image/svg+xml',
      displayType: 'Picture',
    },
    {
      name: 'custom.allergiesTxt',
      label: 'allergiesText',
      helpMessage: 'allergiesTextHelp',
      inputType: 'text',
      displayType: 'Text',
    },
    {
      name: 'custom.backBtnUrl',
      label: 'backBtnUrl',
      helpMessage: 'backBtnUrlHelp',
      inputType: 'text',
      displayType: 'ButtonAirCanada',
    },
    {
      name: 'custom.backBtnText',
      label: 'backBtnText',
      helpMessage: 'backBtnTextHelp',
      inputType: 'text',
      displayType: 'ButtonAirCanada',
    },
  ],
}

const getTypeAndData = (displayType, item) => {
  const field = displayType.split('.')[1]
  const data = item.custom[field]
  const template = TEMPLATES[item.template].find((t) => t.name === displayType)
  return { field, data, template }
}

const ListItem = ({ id, dispatch, appId, displayType }) => {
  const [displayTypeToUse, setDisplayTypeToUse] = useState(displayType)
  const [valueToUse, setValueToUse] = useState(null)
  const { modules } = useContent().get.state
  const currentItem = modules.listitem.list[id]

  useEffect(() => {
    if (!currentItem) dispatch(getModule(appId, 'listitem', id))
  }, [])

  useEffect(() => {
    if (displayType.indexOf('custom.') >= 0) {
      const partInfos = getTypeAndData(displayType, currentItem)
      partInfos.data !== '' && setDisplayTypeToUse(partInfos.template.displayType)
      setValueToUse(partInfos.data)
    }
  }, [displayType])

  const getDisplay = () => {
    switch (displayTypeToUse) {
      case 'ButtonAirCanada':
        return (
          currentItem.custom.backBtnUrl &&
          currentItem.custom.backBtnText && (
            <LinkButton id="back button" href={currentItem.custom.backBtnUrl}>
              {currentItem.custom.backBtnText}
            </LinkButton>
          )
        )
      case 'H2':
        return currentItem.name && <Subtitle text={valueToUse || currentItem.name} />
      case 'Picture':
        return currentItem.img && <Picture alt={currentItem.name} url={valueToUse || currentItem.img} />
      case 'Trigger':
        return (
          currentItem.triggerId && (
            <Trigger appId={appId} id={currentItem.triggerId} type={'listitem'} typeId={id} />
          )
        )
      case 'Text':
        return currentItem.text && <Text text={valueToUse || currentItem.text} />
      default:
        return ''
    }
  }

  return <>{getDisplay()}</>
}

ListItem.propTypes = {
  id: PropTypes.string,
  dispatch: PropTypes.func,
  appId: PropTypes.string,
  modules: PropTypes.any,
  displayType: PropTypes.string,
}

export default ListItem
